import * as React from "react";
import SectionView from "../../layout/section/SectionView";
import InputFormGroup from "../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import LeadStatusForm from "./LeadStatusForm";
import {FormBodyProps} from "../../common/props/FormBodyProps";
import SelectStatusCategoryFormGroup from "../../jobStatus/form/category/SelectStatusCategoryFormGroup";
import LeadStatusCategory from "../../../model/lead/LeadStatusCategory";
import CheckboxFormGroup from "../../ui/form/CheckboxFormGroup";

type Props = FormBodyProps<LeadStatusForm>

export default class LeadStatusFormBody extends React.PureComponent<Props, {}> {
	render() {
		return (
			<SectionView>
				<div className={"c-edit-lead-status"}>
					<InputFormGroup label="Label"
									placeholder="Enter status label"
									field={this.props.form.label}
									onChange={this.props.onFieldChange}
									focus={this.props.form.hasFocus(this.props.form.label)}/>
					<SelectStatusCategoryFormGroup field={this.props.form.category}
												   placeholder={"Select status category"}
												   onChange={this.props.onFieldChange}
												   label={"Category"}
												   items={LeadStatusCategory.getLeadStatusCategories()}/>
					<CheckboxFormGroup field={this.props.form.showPushNotification}
									   onChange={this.props.onFieldChange}
									   label={"Show notification in app"}/>
				</div>
			</SectionView>
		);
	}
}
